<div class="con">
  <div class="title">
    <h1>Setup Induction Questions</h1>
  </div>
  <div class="selection">  
    <mat-form-field>
      <mat-select placeholder="Induction Type" > 
        <mat-option value="option1">Safety Induction</mat-option>
          <mat-option value="option2">On Boarding</mat-option>
      </mat-select>
    </mat-form-field>
    </div>
    
      <div class="row">
        <div class="marg">
        <div class="column"> 
          
            <mat-label style="margin-right: 8px; text-decoration: underline;font-size:x-large;font-style: bold;">First Section</mat-label>
           
      </div>
      </div>
      </div>
      <table style="width:75%; margin-left: 5cm;">
        <tr>
          <th>Question</th>
          <th>Type</th> 
          <th>Slide</th>
          <th style="text-align: left;padding-left: 45px;">Ans</th>
         
        </tr>
        <tr>
          <td>This is the first question</td>
          <td>True/False</td>
          <td>url</td>
          <button  class="crt" mat-icon-button>
            <mat-icon>create</mat-icon>
          </button>
          <button class="crt" mat-icon-button>
            <mat-icon>forum</mat-icon>
          </button>
        </tr>
        <tr>
          <td>Eve</td>
          <td>Jackson</td>
          <td>94</td>
          <button class="crt" mat-icon-button>
            <mat-icon>create</mat-icon>
          </button>
          <button class="crt" mat-icon-button>
            <mat-icon>forum</mat-icon>
          </button>
        </tr>
      </table>
      <div class="row">
        <div class="marg">
        <div class="column">    
            <button class="addworkarea" mat-stroked-button>
              <mat-icon>add</mat-icon>Add Question
            </button>    
        </div>
        </div>
        </div>
        <div class="row">
          <div class="marg">
          <div class="column"> 
            
              <mat-label style="margin-right: 8px; text-decoration: underline;font-size:x-large;font-style: bold;">Second Section</mat-label>
             
        </div>
        </div>
        </div>
        <table style="width:75%; margin-left: 5cm;">
          <tr>
            <th>Question</th>
            <th>Type</th> 
            <th>Slide</th>
            <th style="text-align: left;padding-left: 45px;">Ans</th>
           
          </tr>
          <tr>
            <td>Second section Q1</td>
            <td>True/False</td>
            <td>Second Section</td>
            <button  class="crt" mat-icon-button>
              <mat-icon>create</mat-icon>
            </button>
            <button class="crt" mat-icon-button>
              <mat-icon>forum</mat-icon>
            </button>
          </tr>
          <tr>
            <td>Second section Q2</td>
            <td>True/False</td>
            <td>Second Slide</td>
            <button class="crt" mat-icon-button>
              <mat-icon>create</mat-icon>
            </button>
            <button class="crt" mat-icon-button>
              <mat-icon>forum</mat-icon>
            </button>
          </tr>
          <tr>
            <td>MAINETEC Golden Rules – compliance is mandatory</td>
            <td>True/False</td>
            <td>Second Section</td>
            <button class="crt" mat-icon-button>
              <mat-icon>create</mat-icon>
            </button>
            <button class="crt" mat-icon-button>
              <mat-icon>forum</mat-icon>
            </button>
          </tr>
        </table>
        <div class="row">
          <div class="marg">
          <div class="column">    
              <button class="addworkarea" mat-stroked-button>
                <mat-icon>add</mat-icon>Add Question
              </button>    
          </div>
          </div>
          </div>
        